import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles({
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  mx: {
    margin: '0 15px',
  },
  my: {
    margin: '15px 0',
  },
  title: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '15px 0',
  },
});
export default function LoadingSkeleton() {
  const classes = useStyles();
  return (
    <>
      <Skeleton variant="rect" width="100%" height={200} />
      <div className={classes.title}>
        <Skeleton width="70%" />
        <Skeleton width="70%" />
        <Skeleton width="70%" />
      </div>
      <div className={classes.row}>
        <Skeleton width="40%" className={classes.mx} />
        <Skeleton width="40%" className={classes.mx} />
      </div>
      <div className={classes.row}>
        <Skeleton width="40%" className={classes.mx} />
        <Skeleton width="40%" className={classes.mx} />
      </div>
    </>
  );
}
